import { useContext } from "react";

import { ThemeContext, type ThemeContextValue } from "./theme-context";

/** Read the current theme preference + resolved value from the
 *  ThemeProvider mounted at the app root. Lives in its own file so
 *  ``react-refresh/only-export-components`` stays happy on the
 *  provider module (which has to export the component). (#161) */
export function useTheme(): ThemeContextValue {
  const ctx = useContext(ThemeContext);
  if (!ctx) {
    throw new Error("useTheme called outside ThemeProvider");
  }
  return ctx;
}
